// extracted by mini-css-extract-plugin
export default {"logo":"layout_logo__GQmUP","body":"layout_body__ZssNi","login_container":"layout_login_container__PQriL","avatar":"layout_avatar__oo4pd","avatar_small":"layout_avatar_small__UAfzN"};